var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pointer thumbtack",on:{"click":_vm.togglePinned}},[_c('i',{staticClass:"fas fa-thumbtack"})])}
var staticRenderFns = []

export { render, staticRenderFns }